import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const cutomIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const Loading = () => {
  return <Spin indicator={cutomIcon} />;
};
